<apx-chart *ngIf="hasData; else emptyChart" [series]="series" [chart]="chart" [colors]="chartColors"
  [plotOptions]="plotOptions" [dataLabels]="dataLabels" [legend]="legend" [grid]="grid" [xaxis]="xaxis" [yaxis]="yaxis"
  [tooltip]="tooltip" [states]="states"></apx-chart>

<ng-template #emptyChart>
  <div class="empty-chart" [style.height.px]="height">
    <i class="pi pi-info-circle text-primary mb-3" style="font-size: 2rem"></i>
    <p class="m-0 text-secondary fs-6">No hay datos disponibles</p>
  </div>
</ng-template>
